var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 9.8125L2.31836 8.49017C1.70529 8.08785 1.71938 7.18438 2.3447 6.80137L10.4777 1.81992C10.7982 1.62359 11.2018 1.62359 11.5223 1.81992L19.6553 6.80137C20.2806 7.18438 20.2947 8.08785 19.6816 8.49017L17.6667 9.8125M4.33333 9.8125L2.33178 11.126C1.71539 11.5305 1.73374 12.4402 2.36594 12.8196L3.91667 13.75M4.33333 9.8125L10.4915 13.4496C10.8052 13.6349 11.1948 13.6349 11.5085 13.4496L17.6667 9.8125M3.91667 13.75L1.99585 15.4787C1.49889 15.926 1.57236 16.7256 2.1425 17.0748L10.4777 22.1801C10.7982 22.3764 11.2018 22.3764 11.5223 22.1801L19.8575 17.0748C20.4276 16.7256 20.5011 15.926 20.0041 15.4787L18.0833 13.75M3.91667 13.75L10.4745 17.8004C10.7966 17.9994 11.2034 17.9994 11.5255 17.8004L18.0833 13.75M18.0833 13.75L19.6341 12.8196C20.2663 12.4402 20.2846 11.5305 19.6682 11.126L17.6667 9.8125",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.ad164dc646645c4ce3cd9b2789034aee.svg";
export { ForwardRef as ReactComponent };